// import { Fancybox } from "@fancyapps/ui";
import { gsap, Sine, Power0, Power1, Power2, Power3, Power4 } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollToPlugin)
gsap.registerPlugin(ScrollTrigger);

// import Splide from '@splidejs/splide';


// matchMedia
// =======================================================
// const mediaQuery_lg = window.matchMedia("(min-width: 1100px)");
// const mediaQuery_xl = window.matchMedia("(min-width: 1300px)");
// const mediaQuery_md = window.matchMedia("(min-width: 768px)");


// FUNCTION
// =======================================================
function isInPage(node) {
  return (node === document.body) ? false : document.body.contains(node);
}

function closest(node, selector) {
  // IEや一部ブラウザでは.closet()が実装されていないので自前も用意
  return (
    node.closest ||
    function (_selector) {
      do {
        // nodeとselectorがマッチしたら返す
        if ((node.matches || node.msMatchesSelector).call(node, _selector)) {
          return node;
        }
        // マッチしなかったら親要素を代入
        node = node.parentElement || node.parentNode;
      } while (node !== null && node.nodeType === 1);
      return null;
    }
  ).call(node, selector);
}


// DRAWER
// =======================================================

const menuBtn = document.querySelector('.l-gnav__btn');
const drawer = document.querySelector('.l-gnav');
const drawerLinks = document.querySelectorAll('.l-gnav a');

var tlDrawer = gsap.timeline({
  paused: true,
  onReverseComplete: function () {
    menuBtn.classList.remove("is-open");
  },
});

tlDrawer
  .to( drawer ,{
    duration: 0.2, autoAlpha: 1, pointerEvents: "auto", ease: Power4.ease
  });

tlDrawer.reverse();

menuBtn.addEventListener('click', function (e) {
  e.preventDefault();
  menuBtn.classList.add("is-open");
  tlDrawer.reversed(!tlDrawer.reversed());
});

drawerLinks.forEach( link => {
  link.addEventListener('click', function (e) {
    tlDrawer.reversed(!tlDrawer.reversed());
  });
}); 

// ANCHOR
// =======================================================

document.addEventListener("DOMContentLoaded", () => {
  if (location.hash) {
    const headerHeight = document.querySelector(".l-header").clientHeight;
    setTimeout(() => {
      // window.scrollBy(0, - headerHeight*2);
    },100)
  }
})

function findHashtags(searchText) {
  const regexp = /\B#\w\w+\b/g;
  const result = searchText.match(regexp);
  if (result) {
    return result;
  } else {
    return [];
  }
}

const h = document.querySelector('.l-header');

gsap.utils.toArray('a[href*="#"]').forEach(function(a) {
  a.addEventListener("click", function(e) {

    const href = e.target.getAttribute("href");
    var currentPage = location.href.split('#')[0];
    var path = new URL(href, currentPage);
    var nextPage = path.href.split('#')[0];

    if(currentPage == nextPage ) {
      const hashTag = findHashtags(e.target.getAttribute("href"));
      const targetElm = document.querySelector(hashTag[0]);
  
      if(isInPage(targetElm)){
        e.preventDefault();
        gsap.to( window, {
          duration: 1,
          ease: 'power4.out',
          scrollTo: {
            y: targetElm,
            autoKill: false,
            // offsetY: h.offsetHeight*2, //ヘッダーの高さをセット
          }
        });
      }
    }

  });
});


// COMMON- Accordion
// =======================================================

const accordions = document.querySelectorAll("[data-ac]");
accordions.forEach( accordion => {
  const trigger = accordion.querySelector('[data-ac-trigger]');
  const content = accordion.querySelector('[data-ac-content]');
  trigger.addEventListener('click', function(){
    gsap.to(content, {
      height: (accordion.classList.contains("is-open")) ? 0 : "auto",
      duration: 0.25,
      ease: "power2.inOut"
    });
    trigger.classList.toggle("is-open");
    accordion.classList.toggle("is-open");
  })
});

// COMMON - Scroll Up
// =======================================================

// Scroll Up
const topBtn = document.querySelector('.c-btn__top');
if( isInPage(topBtn) ) {

  topBtn.addEventListener("click", function(e){
    e.preventDefault();
    gsap.to(window, { duration: 0.3, scrollTo: { y: 0, autoKill: false}, ease: 'power2' });
  });

  const fadeInTopBtn = gsap.timeline({
    scrollTrigger: {
      trigger: 'body',
      start: innerHeight/2 + ' top',
      onEnter: () => {
        gsap.to(topBtn, { autoAlpha: 1, duration: 0.4, ease: Sine.easeOut });
      },
      onLeaveBack: () => {
        gsap.to(topBtn, { autoAlpha: 0, duration: 0.4, ease: Sine.easeOut });
      },
    }
  });
}

// SCROLL TRIGGER
// =======================================================

const hrader = document.querySelector('.l-header');
gsap.to(".l-header", {
  scrollTrigger: {
    toggleActions: "play none none reverse", // 上スクロールで戻る
    trigger: "body",
    start: "top top",
    toggleClass: {
      targets: ".l-header", // クラスを切り替える対象の要素
      className: "is-scroll", // クラス名 "active" を切り替える
    },    
  },
});


const fadeInAnimElements = document.querySelectorAll('[data-anim="fadeIn"]');
fadeInAnimElements.forEach( element => {
  gsap.to( element, {
    duration: 0.7,
    autoAlpha: 1,
    ease: Sine.easeInOut,
    scrollTrigger: {
      trigger: element,
      start: "top 75%",
      end: "bottom bottom",
    }
  })  
});



const zoomInAnimElements = document.querySelectorAll('[data-anim="zoomIn"]');
zoomInAnimElements.forEach( element => {
  gsap.to( element, {
    duration: 1,
    scale: 1,
    ease: Sine.easeInOut,
    scrollTrigger: {
      trigger: element,
      start: "top 75%",
      end: "bottom bottom",
    }
  })  
});

const zoomInBlurAnimElements = document.querySelectorAll('[data-anim="zoomInBlur"]');
zoomInBlurAnimElements.forEach( element => {
  gsap.to( element, {
    duration: 0.7,
    scale: 1,
    filter: "blur(0px)",
    ease: Sine.easeInOut,
    scrollTrigger: {
      trigger: element,
      start: "top 75%",
      end: "bottom bottom",
    }
  })  
});

const blurAnimElements = document.querySelectorAll('[data-anim="blur"]');
blurAnimElements.forEach( element => {
  gsap.to( element, {
    duration: 0.7,
    filter: "blur(0px)",
    ease: Sine.easeInOut,
    scrollTrigger: {
      trigger: element,
      start: "top 60%",
      end: "bottom bottom",
    }
  })  
});


const fadeInRightAnimElements = document.querySelectorAll('[data-anim="fadeInRight"]');

fadeInRightAnimElements.forEach( element => {
  gsap.to( element, {
    duration: 1,
    autoAlpha: 1,
    x: 0,
    ease: "power1.out",
    scrollTrigger: {
      trigger: element,
      start: "top 80%",
      end: "bottom bottom",
    }
  })  
});

const fadeInUpAnimElements = document.querySelectorAll('[data-anim="fadeInUp"]');

fadeInUpAnimElements.forEach( element => {
  gsap.to( element, {
    duration: 0.8,
    autoAlpha: 1,
    y: 0,
    ease: Sine.easeInOut,
    scrollTrigger: {
      trigger: element,
      start: "top 80%",
      end: "bottom bottom",
    }
  })  
});

